import React from 'react'
import { makeStyles } from '@mui/styles'
import { parseNumberObject } from 'utils/helpers'
import Tooltip from 'components/generic/tooltip'
import { TICKET_STATUSES } from 'utils/constants'
import { dateFormatter } from 'utils/data-manipulation/valueFormatter'

export const useStyles = makeStyles(theme => ({
  root: {
    border: 'none',
    margin: 32,
    // remove header padding to align headers with column values
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: theme.spacing(0),
    },
    '& .MuiDataGrid-columnHeader': {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    '& .MuiDataGrid-cell': {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    '& .MuiDataGrid-columnSeparator': {
      visibility: 'hidden',
    },
    '& .MuiDataGrid-columnHeader:focus': {
      outline: 'none',
    },
    '& .MuiDataGrid-cell:focus': {
      outline: 'none',
    },
    '& .MuiDataGrid-cell:focus-within': {
      outline: 'none',
    },
  },
}))

export const getActionButtons = (onSubmit, onHideModal) => [
  {
    id: 'select-ticket-button',
    text: 'Select',
    type: 'submit',
    variant: 'contained',
    onClick: () => onSubmit(),
  },
  {
    id: 'exit-merge-tickets-button',
    text: 'Cancel',
    onClick: () => onHideModal(),
  },
]

const makeMaterialsToolTip = materials => (
  <Tooltip content={materials?.toString()}>
    <>{materials.length > 1 ? 'Mixed' : materials.length === 0 ? '-' : materials[0]}</>
  </Tooltip>
)

export const getColumns = () => [
  {
    field: 'ticketNumber',
    headerName: 'Ticket #',
    flex: 1,
  },
  {
    field: 'effectiveDate',
    headerName: 'Date',
    flex: 1,
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 2,
  },
  {
    field: 'materials',
    headerName: 'Material',
    flex: 2,
    renderCell: params => {
      const { materialTypeCommonNames } = params.row
      return makeMaterialsToolTip(materialTypeCommonNames)
    },
  },
  {
    field: 'netWeight',
    headerName: 'Net Weight',
    flex: 2,
    headerAlign: 'right',
    align: 'right',
    renderCell: params => parseNumberObject(params.row.netWeight, { format: 'weight' }),
  },
]

const canBeMerged = status =>
  status === TICKET_STATUSES.INCOMPLETE.id ||
  status === TICKET_STATUSES.SCALE_COMPLETE.id ||
  status === TICKET_STATUSES.PRICE_COMPLETE.id ||
  status === TICKET_STATUSES.APPROVED.id ||
  status === TICKET_STATUSES.TRUCK_IN_YARD.id

export const getRows = (data, ticketId) =>
  (data?.Items || [])
    .slice()
    .sort((a, b) => new Date(b.status?.date) - new Date(a.status?.date))
    .filter(ticket => canBeMerged(ticket.status.value) && ticket.id !== ticketId)
    .map(ticket => ({
      ...ticket,
      ticketNumber: `# ${ticket.ticketId}`,
      effectiveDate: dateFormatter(ticket.effectiveDate),
      status: TICKET_STATUSES[ticket.status.value]?.name,
    }))
